import {
	CUSTOM_ELEMENTS_SCHEMA,
	Component,
	ElementRef,
	ViewChild,
	afterNextRender,
	input,
} from '@angular/core';
import { NgClass } from '@angular/common';
import { RouterLink } from '@angular/router';
import { GuideCategoryUrl } from '@uc/web/shared/data-models';
import { RingedRightArrowSvgComponent } from '@uc/shared/svg';
import { GuidesCardComponent } from '../guides-card/guides-card.component';

@Component({
	selector: 'uc-guides-carousel',
	templateUrl: './guides-carousel.component.html',
	imports: [NgClass, RouterLink, GuidesCardComponent, RingedRightArrowSvgComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class GuidesCarouselComponent {
	guides = input<any>();
	guideTitle = input<string>();
	categoryGuide = input<string>();
	categoryUrl = input<GuideCategoryUrl>();
	next = input<string>();
	prev = input<string>();
	pagination = input<string>();

	@ViewChild('swiperRef') protected swiperRef: ElementRef | undefined;

	constructor() {
		afterNextRender(() => {
			this._initSwiper();
		});
	}

	private _initSwiper() {
		const config = {
			slidesPerView: 1.1,
			spaceBetween: 24,
			loop: false,
			navigation: {
				nextEl: `.${this.next()}`,
				prevEl: `.${this.prev()}`,
			},
			pagination: {
				type: 'fraction',
				el: `.${this.pagination()}`,
			},
			breakpoints: {
				// when window width is >= 480px
				590: {
					slidesPerView: 2,
					spaceBetween: 32,
					slidesPerGroup: 2,
				},
				// when window width is >= 968px
				879: {
					slidesPerView: 3,
					spaceBetween: 32,
					slidesPerGroup: 3,
				},
				1189: {
					slidesPerView: 4,
					spaceBetween: 32,
					slidesPerGroup: 4,
				},
			},
			injectStyles: [
				`
				.swiper-slide {
					height: 100%;
					display: flex;
					border: 1px solid magenta; 
				}
				`,
			],
		};

		const swiperEl = this.swiperRef?.nativeElement;
		Object.assign(swiperEl, config);

		swiperEl.initialize();
	}
}
